<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
          <emp-lookup
            :class-padding="classPadding"
            v-model="selectedEmp"
            label="Employee Code"
            title="Employee"
            :code-value="true"
            :off-remarks="true"
          ></emp-lookup>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="8" :class="classPadding">
          <v-text-field label="Name" :value="selectedEmp.desc" :class="classPadding"></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col xs="12" sm="12" md="12">
          <v-btn outlined @click.stop="exportReport" :loading="loading" :class="classPadding">Export</v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
const API_ENDPOINT = "/api/reports";
const EmpLookup = () =>
  import("../../maintenance/employee-masterfile/personal-info/Lookup");
export default {
  data: () => ({
    classPadding: "my-0 py-0",
    selectedEmp: {},
    loading: false
  }),
  components: {
    EmpLookup
  },
  methods: {
    exportReport() {
      this.loading = true;
      var url = `${API_ENDPOINT}/emp-slip/${this.selectedEmp.code}`;
      this.$axios
        .get(url)
        .then(({ data }) => {
          var subPath = process.env.VUE_APP_PATH;

          window.open(
            `${subPath.slice(0, -1)}/report-viewer?reportCode=${
              data.reportCode
            }&dbName=${data.dbName}&key=${data.key}&companyKey=${
              data.companyKey
            }&reportUrl=${data.url}&client=${data.client}&logoAlign=${
              data.logoAlign
            }&logoWidth=${data.logoWidth}&rpt=${data.rpt}`
          );
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>